import { Navigate } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Link } from "@/components/LLink";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion";
import SEO from "@/components/SEO";
import { useLang, withLang } from "@/i18n";
import { CITIES } from "@/seo/cities";

export default function CitiesHubPage() {
  const { lang } = useLang();
  if (lang !== "ro") return <Navigate to={withLang(lang, "/")} replace />;
  const sorted = [...CITIES].sort((a, b) => a.km - b.km);

  return (
    <div data-testid="cities-hub-page">
      <SEO single title="Zone deservite — Confecții Metalice în toată România | HEAVY METAL" description="Producem în Buzău și livrăm porți, garduri, balustrade, carporturi, pergole, structuri metalice și mobilier urban în toată România: București, Ploiești, Brașov, Constanța, Iași, Cluj-Napoca, Timișoara și alte 11 orașe. Kit gata de montaj, ofertă în 24h." image="/images/structuri-hero.jpg" />
      <PageHero kicker="Zone deservite" title="Un atelier în Buzău, livrare în toată România" subtitle="Toate produsele pleacă din atelierul nostru paletizate sau cu macara-braț și ajung în 1–3 zile lucrătoare în orice oraș din țară — ca kit gata de montaj, cu plan de prindere." image="/images/structuri-hero.jpg" />
      <section className="border-b border-ink/10">
        <div className="px-4 py-24 sm:px-6 lg:px-10 2xl:px-16">
          <p className="kicker">Orașe & județe</p>
          <h2 className="mt-5 font-heading text-3xl font-semibold tracking-tight md:text-[40px]">Alege orașul tău</h2>
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {sorted.map((c, i) => (
              <Reveal key={c.slug} delay={i * 0.03}>
                <Link to={`/confectii-metalice/${c.slug}`} data-testid={`hub-city-${c.slug}`} className="group flex h-full flex-col border border-ink/10 bg-base transition-shadow duration-500 hover:shadow-2xl hover:shadow-black/10">
                  <div className="relative h-40 overflow-hidden bg-[#0b1220]"><img src={c.hero} alt={`Confecții metalice ${c.name}`} loading="lazy" className="h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-[1.05]" /></div>
                  <div className="flex flex-1 flex-col p-6">
                    <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.25em] text-ink/50"><MapPin className="h-3 w-3 text-gold" /> {c.county}</p>
                    <h3 className="mt-2 font-heading text-xl font-semibold text-ink">{c.name}</h3>
                    <p className="mt-2 text-[13px] text-ink/60">{c.km ? `${c.km} km` : "Atelier"} · livrare {c.days}</p>
                    <span className="mt-auto inline-flex items-center gap-2 pt-5 text-[13px] font-semibold text-ink underline decoration-gold decoration-2 underline-offset-[6px] group-hover:text-gold">Confecții metalice {c.name} <ArrowRight className="h-3.5 w-3.5" /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
